import { withClassName } from '@/common/theme/withClassName';
import { SocialStyledPrimaryButton } from '@/components/SocialSignIn/SocialButton/SocialButton';
import Image from 'next/image';
import { HTMLProps } from 'react';
import { GoogleLogo } from '../../Svg';
import styles from '../social-signin.module.scss';

const LoadWrapper = withClassName<HTMLProps<HTMLDivElement>>(
  'div',
  styles.loading_wrapper,
  'GoogleLoadingWrapper',
);

const OverlayWrapper = withClassName<HTMLProps<HTMLDivElement>>(
  'div',
  styles.overlay_wrapper,
  'GoogleOverlayWrapper',
);

const GooglePlaceholder = withClassName(
  SocialStyledPrimaryButton,
  styles.placeholder_btn,
  'GooglePlaceholderBtn',
);

const LogoWrapper = withClassName<HTMLProps<HTMLDivElement>>(
  'div',
  styles.logo_wrapper,
  'GoogleLogoWrapper',
);

const ButtonLoadText = withClassName<HTMLProps<HTMLDivElement>>(
  'div',
  styles.button_text,
  'GoogleButtonText',
);

export const GooglePlaceholderButton = ({
  disabled,
  loading,
  onPlaceholderClicked,
}: {
  disabled: boolean;
  loading: boolean;
  onPlaceholderClicked: () => void;
}) => (
  <GooglePlaceholder
    id="google-continue-button"
    data-testid="google-continue-button"
    disabled={disabled}
    onClick={onPlaceholderClicked}
  >
    <OverlayWrapper>
      <LogoWrapper>
        <GoogleLogo />
      </LogoWrapper>
      <ButtonLoadText>Continue with Google</ButtonLoadText>
    </OverlayWrapper>
    <LoadWrapper>
      {loading && (
        <Image
          src={`${process.env.ASSET_PREFIX}/images/circle-loader.svg`}
          alt="button-loader"
          data-testid="button-loader"
          width={24}
          height={24}
          className={styles.loading_image}
        />
      )}
    </LoadWrapper>
  </GooglePlaceholder>
);
